import { useState } from 'react'
import { useAuthStore } from '../../stores/authStore'
import { Link, useNavigate } from 'react-router-dom'

export default function Header() {
  const { user, activeTenant, isDemo, isAuthenticated, logout, setActiveTenant } = useAuthStore()
  const navigate = useNavigate()
  const [showTenantDropdown, setShowTenantDropdown] = useState(false)

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-8">
      {/* Left: Business name and industry */}
      <div className="flex items-center space-x-4">
        <div>
          <div className="flex items-center space-x-2">
            <h1 className="text-lg font-semibold text-gray-900">
              {activeTenant?.businessName || 'AutoLedger'}
            </h1>
            {/* Tenant switcher dropdown (if user has multiple tenants) */}
            {isAuthenticated && user?.tenants && user.tenants.length > 1 && (
              <div className="relative">
                <button
                  onClick={() => setShowTenantDropdown(!showTenantDropdown)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {showTenantDropdown && (
                  <div className="absolute top-8 left-0 bg-white border border-gray-200 rounded-lg shadow-lg py-2 min-w-48 z-50">
                    {user.tenants.map((tenant) => (
                      <button
                        key={tenant.tenantId}
                        onClick={() => {
                          setActiveTenant(tenant)
                          setShowTenantDropdown(false)
                        }}
                        className={`w-full text-left px-4 py-2 hover:bg-gray-50 ${
                          activeTenant?.tenantId === tenant.tenantId ? 'bg-primary-50 text-primary-700' : ''
                        }`}
                      >
                        <div className="font-medium">{tenant.businessName}</div>
                        <div className="text-xs text-gray-500 capitalize">{tenant.industry}</div>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
          <p className="text-sm text-gray-500 capitalize">
            {activeTenant?.industry || 'Restaurant'} Bookkeeping
          </p>
        </div>
      </div>

      {/* Right: Demo badge, user info, login/logout */}
      <div className="flex items-center space-x-4">
        {/* Demo mode indicator */}
        {isDemo && (
          <div className="flex items-center space-x-2">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
              <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              Demo Mode
            </span>
            <Link
              to="/login"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium"
            >
              Sign in
            </Link>
          </div>
        )}

        {/* Authenticated user info */}
        {isAuthenticated && user && (
          <>
            <span className="text-sm text-gray-600">{user.email}</span>
            <button
              onClick={handleLogout}
              className="text-sm text-gray-500 hover:text-gray-700"
            >
              Logout
            </button>
          </>
        )}
      </div>
    </header>
  )
}
